// module_configs/hardware.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faHammer, faUsersCog, faClock, faWrench
} from '@fortawesome/free-solid-svg-icons';

// Import Hardware components
import DashboardHome from '.././module_hardware/hardware_DashHome';

import AddCustomer from '.././module_mechanics/mechanics_customer';

import CustomerList from '.././module_mechanics/mechanics_customer_list';

import AddSupplier from '.././module_mechanics/mechanics_Supplier';

import SupplierList from '.././module_mechanics/mechanics_SuppliersList';

import AddEmployee from '.././module_mechanics/mechanics_employees';

import MecEmployeeList from '.././module_mechanics/mechanic_employeelist';

import HardwareProduct from '.././module_hardware/hardware_Products';

import HardwareProductsList from '.././module_hardware/hardware_ProductsList';

import HardwarePurchases from '.././module_hardware/hardware_Purchases';

import HardwarePurchaseList from '.././module_hardware/hardware_PurchaseList';

import HardwareReturn from '.././module_hardware/hardware_Return';

import HardwareReturnList from '.././module_hardware/hardware_ReturnList';

import HardwareSell from '.././module_hardware/hardware_Sell';

import HardwareSalesList from '.././module_hardware/hardware_SellList';

import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

import AddTransactionForm from '.././module_cosmetics/cosmetics_addtransactions';

import CosmeticsTransactions from '.././module_cosmetics/cosmetics_transactions';

import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';

import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';

export const hardwareConfig = {
  moduleId: 'hardware',
  moduleName: 'Hardware',
  icon: faHammer,
  description: 'Hardware Store Management System',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_hardwareth': { level: 1, label: 'Admin (Thermal)', color: '#f97316' },
    'manager_hardwareth': { level: 2, label: 'Manager (Thermal)', color: '#ea580c' },
    'user_hardwareth': { level: 3, label: 'User (Thermal)', color: '#c2410c' },
    'viewer_hardwareth': { level: 4, label: 'Viewer (Thermal)', color: '#9a3412' },
    'admin_hardwareap': { level: 1, label: 'Admin (Large)', color: '#d97706' },
    'manager_hardwareap': { level: 2, label: 'Manager (Large)', color: '#b45309' },
    'user_hardwareap': { level: 3, label: 'User (Large)', color: '#92400e' },
    'viewer_hardwareap': { level: 4, label: 'Viewer (Large)', color: '#78350f' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomerList,
          icon: faUsersLine,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserTie,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faBuildingUser,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'admin_hardwareap', 'manager_hardwareap'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'admin_hardwareap', 'manager_hardwareap']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MecEmployeeList,
          icon: faIdCard,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'admin_hardwareap', 'manager_hardwareap']
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock',
      icon: faCubes,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: HardwareProduct,
          icon: faCube,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: HardwareProductsList,
          icon: faListAlt,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap'],
      groupId: 'inventory',
      position: 5,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: HardwarePurchases,
          icon: faCartPlus,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: HardwarePurchaseList,
          icon: faFileInvoice,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: CosmeticsSupplierPurchases,
          icon: faBuilding,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: CosmeticsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Returns',
      icon: faArrowRotateLeft,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          component: HardwareReturn,
          icon: faRotateLeft,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        },
        {
          id: 'returnlist',
          label: 'Return List',
          component: HardwareReturnList,
          icon: faListCheck,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap'],
      groupId: 'sales',
      position: 7,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: HardwareSell,
          icon: faCartPlus,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: HardwareSalesList,
          icon: faClipboardList,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        }
      ]
    },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: faArrowRightArrowLeft,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'admin_hardwareap', 'manager_hardwareap'],
      groupId: 'sales',
      position: 8,
      submenus: [
        {
          id: 'addtransaction',
          label: 'Add Transaction',
          component: AddTransactionForm,
          icon: faPlus,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'admin_hardwareap', 'manager_hardwareap']
        },
        {
          id: 'transactionsmanager',
          label: 'Transactions',
          component: CosmeticsTransactions,
          icon: faMoneyBillWave,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'admin_hardwareap', 'manager_hardwareap']
        }
      ]
    },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap'],
      groupId: 'inventory',
      position: 9,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: MechanicsBarcode,
          icon: faPrint,
          roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap']
        }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_hardwareth', 'admin_hardwareap'],
      groupId: 'system',
      position: 10,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'admin_hardwareap', 'manager_hardwareap', 'user_hardwareap'],
      groupId: 'system',
      position: 11,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$1,890' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 345 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 78 },
    { id: 'pending', label: 'Pending Orders', icon: 'faClock', value: 8 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + C', description: 'Add Customer' },
    { key: 'Alt + L', description: 'Customer List' },
    { key: 'Alt + P', description: 'Stock List' },
    { key: 'Alt + S', description: 'New Sale' },
    { key: 'Alt + U', description: 'New Purchase' },
    { key: 'Alt + R', description: 'New Return' },
    { key: 'Alt + E', description: 'Add Employee' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};